<template>
  <div>
    <!-- SECCIÓN 1: SOBRES / REGALO -->
    <section ref="raiz" class="lluvia-sobres">
      <div class="contenido">
        <h2 ref="tituloRef" class="titulo">
          <span class="serif">Con</span><br />
          <span class="script">Cariño<br><br></span>
        </h2>

        <p ref="textoRef" class="texto">
          Tu presencia es el regalo más valioso para mí. ✨  
          Pero si deseas tener un detalle, lo recibiré con mucho aprecio  
          y profunda gratitud, sin ser en absoluto una obligación.
        </p>

        <img
          ref="sobreRef"
          :src="sobrePng"
          alt="Sobre"
          class="icono-sobre"
        />

        <p ref="graciasRef" class="gracias">Lluvia de sobres</p>
      </div>

      <div ref="lluviaIzq" class="lluvia lluvia-izq"></div>
      <div ref="lluviaDer" class="lluvia lluvia-der"></div>
    </section>

    <section ref="raizNinos" class="lluvia-sobres">
      <div class="contenido">
        <h2 ref="tituloNinosRef" class="titulo">
          <span class="serif">¡ No Niños!<br></span>  
        </h2>

        <p ref="textoNinosRef" class="texto">
          Con todo el amor que le tenemos a sus pequeñitos, hemos decidido que esta ocasión sea una recepción solo para adultos. Les agradecemos de corazón su comprensión y por ayudarnos a hacer de esta noche algo inolvidable.
        </p>
      </div>

      <div ref="lluviaNinosIzq" class="lluvia lluvia-izq"></div>
      <div ref="lluviaNinosDer" class="lluvia lluvia-der"></div>

      <div class="rasgado rasgado-inferior"></div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sobrePng from '@/assets/ss.png'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'LluviaDeSobres',
  setup() {
    const raiz = ref(null)
    const tituloRef = ref(null)
    const textoRef = ref(null)
    const sobreRef = ref(null)
    const graciasRef = ref(null)
    const lluviaIzq = ref(null)
    const lluviaDer = ref(null)

    const raizNinos = ref(null)
    const tituloNinosRef = ref(null)
    const textoNinosRef = ref(null)
    const lluviaNinosIzq = ref(null)
    const lluviaNinosDer = ref(null)

    let ctx = null

    // Genera y posiciona dinámicamente las imágenes de sobres dentro del contenedor
    const crearLluvia = (contenedorEl, lado, cantidad) => {
      if (!contenedorEl) return []
      contenedorEl.innerHTML = '' // Limpiar ejecuciones previas
      const elementos = []
      
      for (let i = 0; i < cantidad; i++) {
        const el = document.createElement('img')
        el.src = sobrePng
        el.className = 'sobre-lluvia'
        contenedorEl.appendChild(el)
        elementos.push(el)
      }
      return elementos
    }

    onMounted(async () => {
      await nextTick()

      ctx = gsap.context(() => {
        // ==========================================
        // --- SECCIÓN 1: SOBRES Y REGALO (SCRUB) ---
        // ==========================================
        const elementosIzq1 = crearLluvia(lluviaIzq.value, 'izq', 8)
        const elementosDer1 = crearLluvia(lluviaDer.value, 'der', 8)

        const tl1 = gsap.timeline({
          scrollTrigger: {
            trigger: raiz.value,
            start: 'top 85%', // Comienza al asomar en la pantalla
            end: 'top 20%',   // Finaliza casi al llegar arriba
            scrub: 1          // Suavizado de 1 segundo atado al scroll
          }
        })

        // Entrada progresiva del contenido
        tl1.fromTo(
          tituloRef.value,
          { opacity: 0, y: 50, filter: 'blur(8px)' },
          { opacity: 1, y: 0, filter: 'blur(0px)', ease: 'none' }
        )
        .fromTo(
          textoRef.value,
          { opacity: 0, y: 35 },
          { opacity: 1, y: 0, ease: 'none' },
          '<'
        )
        .fromTo(
          sobreRef.value,
          { opacity: 0, scale: 0.4, rotation: -15 },
          { opacity: 1, scale: 1, rotation: 0, ease: 'none' },
          '-=0.2'
        )
        .fromTo(
          graciasRef.value,
          { opacity: 0, letterSpacing: '0.3em' },
          { opacity: 1, letterSpacing: '0.1em', ease: 'none' },
          '<'
        )

        // Animación progresiva de la lluvia de sobres ligada al scroll
        if (elementosDer1.length) {
          tl1.fromTo(
            elementosDer1,
            { xPercent: 110, yPercent: -10, opacity: 0 },
            {
              xPercent: (i) => -20 - (i * 10),
              yPercent: (i) => 100 + (i * 15),
              opacity: 0.9,
              stagger: 0.05,
              ease: 'none'
            },
            '<'
          )
        }

        if (elementosIzq1.length) {
          tl1.fromTo(
            elementosIzq1,
            { xPercent: -10, yPercent: -10, opacity: 0 },
            {
              xPercent: (i) => 110 + (i * 10),
              yPercent: (i) => 100 + (i * 15),
              opacity: 0.9,
              stagger: 0.05,
              ease: 'none'
            },
            '<'
          )
        }

        // ==========================================
        // --- SECCIÓN 2: RECEPCIÓN ADULTOS (SCRUB) -
        // ==========================================
        const elementosIzq2 = crearLluvia(lluviaNinosIzq.value, 'izq', 8)
        const elementosDer2 = crearLluvia(lluviaNinosDer.value, 'der', 8)

        const tl2 = gsap.timeline({
          scrollTrigger: {
            trigger: raizNinos.value,
            start: 'top 85%',
            end: 'top 20%',
            scrub: 1
          }
        })

        tl2.fromTo(
          tituloNinosRef.value,
          { opacity: 0, y: 50, filter: 'blur(8px)' },
          { opacity: 1, y: 0, filter: 'blur(0px)', ease: 'none' }
        )
        .fromTo(
          textoNinosRef.value,
          { opacity: 0, y: 35 },
          { opacity: 1, y: 0, ease: 'none' },
          '<'
        )

        if (elementosDer2.length) {
          tl2.fromTo(
            elementosDer2,
            { xPercent: 110, yPercent: -10, opacity: 0 },
            {
              xPercent: (i) => -20 - (i * 10),
              yPercent: (i) => 100 + (i * 15),
              opacity: 0.9,
              stagger: 0.05,
              ease: 'none'
            },
            '<'
          )
        }

        if (elementosIzq2.length) {
          tl2.fromTo(
            elementosIzq2,
            { xPercent: -10, yPercent: -10, opacity: 0 },
            {
              xPercent: (i) => 110 + (i * 10),
              yPercent: (i) => 100 + (i * 15),
              opacity: 0.9,
              stagger: 0.05,
              ease: 'none'
            },
            '<'
          )
        }

      })

      setTimeout(() => {
        ScrollTrigger.refresh()
      }, 400)
    })

    onUnmounted(() => {
      if (ctx) ctx.revert()
    })

    return {
      raiz,
      tituloRef,
      textoRef,
      sobreRef,
      graciasRef,
      lluviaIzq,
      lluviaDer,
      raizNinos,
      tituloNinosRef,
      textoNinosRef,
      lluviaNinosIzq,
      lluviaNinosDer,
      sobrePng
    }
  }
}
</script>

<style scoped>
/* CONTENEDOR */
.lluvia-sobres{
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 48px 20px 56px;
  text-align: center;
  background: #f0c9d3;
  overflow: hidden;
}

/* CONTENIDO */
.contenido{
  position: relative;
  z-index: 2;
}

/* TITULO */
.titulo{
  margin: 0 0 10px;
  color: #fff;
  line-height: 1.05;
}

.titulo .serif{
  font-family: 'british', serif;
  font-size: 36px;
  display: inline-block;
  line-height: 2.3;
  padding-bottom: 5px;; /* Recomendado: escala automáticamente */
}

.titulo .script{
   font-family: 'british', serif;
  font-size: 36px;
  opacity: .95;
}

/* TEXTO */
.texto{
  font-family: 'quote', serif;
  font-size: 17px;
  line-height: 1.5;
  color: #fff;
  max-width: 420px;
  margin: 12px auto 18px;
}

/* SOBRE CENTRAL */
.icono-sobre{
  width: 128px;
  max-width: 28vw;
  margin: 18px auto 10px;
  display: block;
  filter: drop-shadow(0 8px 14px rgba(0,0,0,.15));
  will-change: transform, opacity;
}

/* GRACIAS */
.gracias{
  font-family: 'padres', serif;
  font-size: 19px;
  letter-spacing: .08em;
  color: #fff;
  font-weight: 800;
}

/* LLUVIA */
.lluvia{
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}

.sobre-lluvia{
  position: absolute;
  width: 28px;
  top: 0%;
  opacity: 0;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,.1));
  will-change: transform, opacity;
}
</style>